import React, { Component } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Button,
  TabContent,
  TabPane,
} from "reactstrap";
import SweetAlert from "react-bootstrap-sweetalert";
// availity-reactstrap-validation
import { AvForm, AvField } from "availity-reactstrap-validation";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
//Constants
import { API_WEB_URLS } from "../../constants/constAPI";
//Store
import { compose } from "recompose";
import { container } from "../../store/Containers/cntCommon";
import {
  Fn_DisplayData,
  Fn_AddEditData,
  Fn_FillListData,
  showToastWithCloseButton,
} from "../../store/functions";

class pageAddEdit_UserRights extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: 0,
      memberid: 0,
      formData: {},
      UserMaster: [],
      SubMenuMasterNew: [],
      UserRole: [],
      activeTab: 1,
      passedSteps: [1],
      success_msg: false,
    };

    this.obj = this;
    this.formTitle = "User Rights";
    this.breadCrumbTitle = "User Rights";
    this.breadCrumbItem = "Add " + this.formTitle;
    this.API_URL = API_WEB_URLS.MASTER + "/0/token/UserRightsMasterr";
    this.API_URL_SAVE = API_WEB_URLS.UserRights + "/0/token";
    this.pushFormName = "/UserRights";

    //Event Binding
    this.btnSave_onClick = this.btnSave_onClick.bind(this);
    this.btnCancel_onClick = this.btnCancel_onClick.bind(this);
    this.btnGoBack_onClick = this.btnGoBack_onClick.bind(this);
    this.syno = this.syno.bind(this);
  }

  componentDidMount() {
    this.setState({});

    //Filling DropDowns
    Fn_FillListData(
      this.obj,
      "UserRole",
      API_WEB_URLS.MASTER + "/0/token/UserRole/Id/0"
    );

    Fn_FillListData(
      this.obj,
      "SubMenuMasterNew",
      API_WEB_URLS.MASTER + "/0/token/SubMenuMasterNew/Id/0"
    );

    const { id } = this.props.match.params;
    if (id) {
      this.setState({ id: id });
      this.breadCrumbItem = "Edit " + this.formTitle;
      this.loadEditData(id);
    } else {
      this.setState({ id: 0 });
    }
  }

  loadEditData = async (id) => {
    try {
      const response = await this.customDisplayData(id, this.API_URL + "/Id");
      if (response) {
        console.log("API Response:", response); // Debug log
        
        // Wait for dropdowns to be loaded first
        await this.waitForDropdowns();
        
        // Map the API response to form fields
        const mappedData = {
          ...response,
          F_UserRole: this.findIdByName(this.state.UserRole, response.UserRole) || response.UserRoleId || response.F_UserRole || "-1",
          F_UserMaster: this.findIdByName(this.state.UserMaster, response.UserName) || response.UserId || response.F_UserMaster || "-1", 
          F_SubMenuMasterNew: this.findIdByName(this.state.SubMenuMasterNew, response.SubMenu) || response.SubMenuId || response.F_SubMenuMasterNew || "-1",
          IsAdd: response.IsAdd == 1,
          IsEdit: response.IsEdit == 1,
          IsDelete: response.IsDelete == 1,
          IsView: response.IsView == 1,
          IsPrint: response.IsPrint == 1,
        };

        console.log("Mapped Data:", mappedData); // Debug log
        console.log("UserRole Array:", this.state.UserRole); // Debug log
        console.log("Found UserRole ID:", this.findIdByName(this.state.UserRole, response.UserRole)); // Debug log

        this.setState({ formData: mappedData }, () => {
          // If we have UserRole, load the corresponding users
          if (mappedData.F_UserRole && mappedData.F_UserRole !== "-1") {
            Fn_FillListData(
              this.obj,
              "UserMaster",
              API_WEB_URLS.MASTER + "/0/token/UserMaster/Id/" + mappedData.F_UserRole
            );
          }
        });
      }
    } catch (error) {
      console.error("Error loading edit data:", error);
    }
  }

  waitForDropdowns = () => {
    return new Promise((resolve) => {
      const checkDropdowns = () => {
        if (this.state.UserRole && this.state.UserRole.length > 0 && 
            this.state.SubMenuMasterNew && this.state.SubMenuMasterNew.length > 0) {
          resolve();
        } else {
          setTimeout(checkDropdowns, 100);
        }
      };
      checkDropdowns();
    });
  }

  findIdByName = (array, name) => {
    if (!array || !name) return null;
    console.log("Searching for name:", name, "in array:", array);
    
    // Try exact match first
    let item = array.find(item => item.Name === name);
    
    // If not found, try case-insensitive match
    if (!item) {
      item = array.find(item => item.Name && item.Name.toLowerCase() === name.toLowerCase());
    }
    
    // If still not found, try partial match
    if (!item) {
      item = array.find(item => item.Name && item.Name.toLowerCase().includes(name.toLowerCase()));
    }
    
    console.log("Found item:", item);
    return item ? item.Id : null;
  }

  customDisplayData = (id, apiURL) => {
    return new Promise((resolve, reject) => {
      const request = {
        id: id,
        apiURL: apiURL,
        callback: (response) => {
          if (response && response.status === 200 && response.data) {
            resolve(response.data.dataList[0]);
          } else {
            showToastWithCloseButton("error", "Some error occurred while displaying data");
            reject(new Error("Failed to fetch data"));
          }
        },
      };
      this.props.callGet_Data(request);
    });
  }

  handleUserRoleChange = event => {
    const userRoleId = event.target.value;

    // Update form data
    this.setState(prevState => ({
      formData: {
        ...prevState.formData,
        F_UserRole: userRoleId,
        F_UserMaster: "-1", // Reset User Master when role changes
      },
    }));

    // Load users based on selected role
    if (userRoleId && userRoleId !== "-1") {
      Fn_FillListData(
        this.obj,
        "UserMaster",
        API_WEB_URLS.MASTER + "/0/token/UserMaster/Id/" + userRoleId
      );
    } else {
      // If no role selected, clear user list
      this.setState({ UserMaster: [] });
    }
  };

  btnSave_onClick(event, formData) {
    const obj = JSON.parse( sessionStorage.getItem("authUser"));

    let vformData = new FormData();

    vformData.append("F_SubMenuMasterNew", formData.F_SubMenuMasterNew);
    vformData.append("F_UserMaster", formData.F_UserMaster);
    vformData.append("F_UserRole", formData.F_UserRole);
    vformData.append("UserId", obj.uid);
    vformData.append("IsAdd", formData.IsAdd ? "true" : "false");
    vformData.append("IsEdit", formData.IsEdit ? "true" : "false");
    vformData.append("IsDelete", formData.IsDelete ? "true" : "false");
    vformData.append("IsView", formData.IsView ? "true" : "false");
    vformData.append("IsPrint", formData.IsPrint ? "true" : "false");

    if (!this.state.id) {
      Fn_AddEditData(
        this.obj,
        { arguList: { id: 0, formData: vformData } },
        this.API_URL_SAVE,
        this.pushFormName,
        true,
        "memberid"
      );
    } else
      Fn_AddEditData(
        this.obj,
        { arguList: { id: this.state.id, formData: vformData } },
        this.API_URL_SAVE,
        this.pushFormName,
        true,
        "kuku"
      );
  }

  btnGoBack_onClick = event => {
    event.preventDefault();
    //this.props.history.goBack();
    this.props.history.push(this.pushFormName);
  };

  btnCancel_onClick = event => {
    event.preventDefault();
    //this.props.history.goBack();
    this.props.history.push(this.pushFormName);
  };

  syno = () => {
    this.setState({ success_msg: false });
    this.props.history.push(this.pushFormName);
  };

  render() {
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid>
            {/* Render Breadcrumb */}
            <Breadcrumbs
              title={this.breadCrumbTitle}
              breadcrumbItem={this.breadCrumbItem}
            />
            <Row>
              <Col lg="12">
                <Card>
                  <CardBody>
                    {/* <h4 className="card-title mb-4">Basic Wizard</h4> */}
                    <div className="wizard clearfix">
                      <div className="content clearfix">
                        <AvForm
                          className="needs-validation"
                          onValidSubmit={this.btnSave_onClick}
                        >
                          <TabContent
                            activeTab={this.state.activeTab}
                            className="body"
                          >
                            <TabPane tabId={1}>
                              <Row>
                                <Col lg="8">
                                  <Card>
                                    <CardBody>
                                      <h4 className="card-title mb-4">
                                        User Rights Configuration
                                      </h4>

                                      <Row>
                                        <Col sm="4" className="mb-3">
                                          <label
                                            htmlFor="F_UserRole"
                                            className="col-form-label"
                                          >
                                            User Role *
                                          </label>
                                        </Col>
                                        <Col sm="8">
                                          <AvField
                                            name="F_UserRole"
                                            label=""
                                            value={
                                              this.state.formData.F_UserRole ===
                                              null
                                                ? "-1"
                                                : this.state.formData.F_UserRole
                                            }
                                            placeholder="User Role"
                                            errorMessage="Please select user role"
                                            validate={{
                                              required: { value: true },
                                            }}
                                            type="select"
                                            className="form-select"
                                            onChange={this.handleUserRoleChange}
                                          >
                                            <option value="-1" defaultValue>
                                              Select Role
                                            </option>
                                            {this.state.UserRole
                                              ? this.state.UserRole.map(
                                                  (option, key) => (
                                                    <option
                                                      key={option.Id}
                                                      value={option.Id}
                                                      label={option.Name}
                                                    />
                                                  )
                                                )
                                              : null}
                                          </AvField>
                                        </Col>
                                      </Row>

                                      <Row>
                                        <Col sm="4" className="mb-3">
                                          <label
                                            htmlFor="F_UserMaster"
                                            className="col-form-label"
                                          >
                                            User Name *
                                          </label>
                                        </Col>
                                        <Col sm="8">
                                          <AvField
                                            name="F_UserMaster"
                                            label=""
                                            value={
                                              this.state.formData
                                                .F_UserMaster === null
                                                ? "-1"
                                                : this.state.formData
                                                    .F_UserMaster
                                            }
                                            errorMessage="Please select a user"
                                            validate={{
                                              required: { value: true },
                                            }}
                                            type="select"
                                            className="form-select"
                                            disabled={
                                              !this.state.formData.F_UserRole ||
                                              this.state.formData.F_UserRole ===
                                                "-1"
                                            }
                                          >
                                            <option value="-1" defaultValue>
                                              {!this.state.formData
                                                .F_UserRole ||
                                              this.state.formData.F_UserRole ===
                                                "-1"
                                                ? "Please select a role first"
                                                : "Select User"}
                                            </option>
                                            {this.state.UserMaster
                                              ? this.state.UserMaster.map(
                                                  (option, key) => (
                                                    <option
                                                      key={option.Id}
                                                      value={option.Id}
                                                      label={option.Name}
                                                    />
                                                  )
                                                )
                                              : null}
                                          </AvField>
                                        </Col>
                                      </Row>

                                      <Row>
                                        <Col sm="4" className="mb-3">
                                          <label
                                            htmlFor="F_SubMenuMasterNew"
                                            className="col-form-label"
                                          >
                                            Sub Menu Name
                                          </label>
                                        </Col>
                                        <Col sm="8">
                                          <AvField
                                            name="F_SubMenuMasterNew"
                                            label=""
                                            value={
                                              this.state.formData
                                                .F_SubMenuMasterNew === null
                                                ? "-1"
                                                : this.state.formData
                                                    .F_SubMenuMasterNew
                                            }
                                            placeholder="Sub Menu Name"
                                            errorMessage="Please select sub menu"
                                            validate={{
                                              required: { value: false },
                                            }}
                                            type="select"
                                            className="form-select"
                                          >
                                            <option value="-1" defaultValue>
                                              Select Sub Menu
                                            </option>
                                            {this.state.SubMenuMasterNew
                                              ? this.state.SubMenuMasterNew.map(
                                                  (option, key) => (
                                                    <option
                                                      key={option.Id}
                                                      value={option.Id}
                                                      label={option.Name}
                                                    />
                                                  )
                                                )
                                              : null}
                                          </AvField>
                                        </Col>
                                      </Row>

                                      <Row>
                                        <Col sm="4" className="mb-3">
                                          <label className="col-form-label">
                                            Permissions
                                          </label>
                                        </Col>
                                        <Col sm="8">
                                          <div className="row">
                                            <Col sm="6">
                                              <div className="form-check mb-2">
                                                <AvField
                                                  name="IsAdd"
                                                  type="checkbox"
                                                  className="form-check-input"
                                                  checked={
                                                    this.state.formData
                                                      .IsAdd === null
                                                      ? false
                                                      : this.state.formData
                                                          .IsAdd
                                                  }
                                                />
                                                <label
                                                  className="form-check-label"
                                                  htmlFor="IsAdd"
                                                >
                                                  Add Permission
                                                </label>
                                              </div>
                                            </Col>
                                            <Col sm="6">
                                              <div className="form-check mb-2">
                                                <AvField
                                                  name="IsEdit"
                                                  type="checkbox"
                                                  className="form-check-input"
                                                  checked={
                                                    this.state.formData
                                                      .IsEdit === null
                                                      ? false
                                                      : this.state.formData
                                                          .IsEdit
                                                  }
                                                />
                                                <label
                                                  className="form-check-label"
                                                  htmlFor="IsEdit"
                                                >
                                                  Edit Permission
                                                </label>
                                              </div>
                                            </Col>
                                            <Col sm="6">
                                              <div className="form-check mb-2">
                                                <AvField
                                                  name="IsDelete"
                                                  type="checkbox"
                                                  className="form-check-input"
                                                  checked={
                                                    this.state.formData
                                                      .IsDelete === null
                                                      ? false
                                                      : this.state.formData
                                                          .IsDelete
                                                  }
                                                />
                                                <label
                                                  className="form-check-label"
                                                  htmlFor="IsDelete"
                                                >
                                                  Delete Permission
                                                </label>
                                              </div>
                                            </Col>
                                            <Col sm="6">
                                              <div className="form-check mb-2">
                                                <AvField
                                                  name="IsView"
                                                  type="checkbox"
                                                  className="form-check-input"
                                                  checked={
                                                    this.state.formData
                                                      .IsView === null
                                                      ? false
                                                      : this.state.formData
                                                          .IsView
                                                  }
                                                />
                                                <label
                                                  className="form-check-label"
                                                  htmlFor="IsView"
                                                >
                                                  View Permission
                                                </label>
                                              </div>
                                            </Col>

                                            <Col sm="6">
                                              <div className="form-check mb-2">
                                                <AvField
                                                  name="IsPrint"
                                                  type="checkbox"
                                                  className="form-check-input"
                                                  checked={
                                                    this.state.formData
                                                      .IsPrint === null
                                                      ? false
                                                      : this.state.formData
                                                          .IsPrint
                                                  }
                                                />
                                                <label
                                                  className="form-check-label"
                                                  htmlFor="IsPrint"
                                                >
                                                  Print Permission
                                                </label>
                                              </div>
                                            </Col>
                                          </div>
                                        </Col>
                                      </Row>
                                    </CardBody>
                                  </Card>
                                </Col>
                              </Row>
                            </TabPane>
                          </TabContent>
                          <div className="mt-3">
                            <Button
                              type="submit"
                              color="primary"
                              className="mr-1 waves-effect waves-light"
                            >
                              Save
                            </Button>
                            &nbsp;
                            <Button
                              type="button"
                              color="secondary"
                              className="mr-1 waves-effect waves-light"
                              onClick={this.btnGoBack_onClick}
                            >
                              Go Back
                            </Button>
                            {this.state.success_msg ? (
                              <SweetAlert
                                title="User Rights Saved Successfully!"
                                success
                                confirmBtnBsStyle="success"
                                onConfirm={this.syno}
                              >
                                User rights have been saved successfully!
                              </SweetAlert>
                            ) : null}
                          </div>
                        </AvForm>
                      </div>
                      <div className="actions clearfix">
                        <ul>
                          <li
                            className={
                              this.state.activeTab === 1
                                ? "save disabled"
                                : "save"
                            }
                          ></li>
                        </ul>
                      </div>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}
export default compose(container)(pageAddEdit_UserRights);
